module.exports = __webpack_public_path__ + "static/media/global-partner.bc424eec.svg";